(() => {
  const personalisationHandles = new Set(["cycolinks-personalised-name-necklace","cycolinks-custom-10mm-personalised-bracelet","cycolinks-custom-16mm-mens-personalised","cycolinks-personalised-gold-mens-bike-c","personalised-stainless-steel-leather-bracelet","cycolinks-custom-name-adjustable-rope-bracelet","cycolinks-custom-vinyl-clock","cycolinks-custom-name-mtb-vinyl-clock","cycolinks-custom-name-bicycle-vinyl-clock","cycolinks-custom-name-road-bike-clock","cycolinks-custom-name-mtb-wooden-clock","cycolinks-custom-name-mtb-wooden-clock-1","cycolinks-custom-10mm-personalised-id-bracelet","cycolinks-custom-10mm-rose-gold-crystal-personalised-id-bracelet","cycolinks-custom-16mm-black-mens-personalised-id-bike-chain-bracelet","custom-bike-silhouette-t-shirt-your-ride-your-style","cycolinks-custom-10mm-black-personalised-id-bracelet","cycolinks-10mm-black-crystal-personalised-id-bike-chain-bracelet"]);
  const label = document.currentScript.dataset.cycoPersonaliseLabel;
  const cardSelector = '.vtl-product-card';
  const buttonSelector = '.vtl-product-card__atc-button';
  const destinationFor = card => {
    const link = card.querySelector('a.vtl-product-card__title[href]');
    if (!link) return null;
    const url = new URL(link.href, window.location.href);
    const handle = url.pathname.match(/\/products\/([^/?#]+)/)?.[1];
    if (url.origin !== window.location.origin || !personalisationHandles.has(handle)) return null;
    const selected = card.querySelector('[data-selected-value]')?.getAttribute('data-selected-value');
    if (selected && /^\d+$/.test(selected)) url.searchParams.set('variant', selected);
    return url;
  };
  const prepareCard = card => {
    if (!destinationFor(card)) return;
    const button = card.querySelector(buttonSelector);
    if (!button || button.dataset.cycoPersonalise === 'true') return;
    button.dataset.cycoPersonalise = 'true';
    button.textContent = label;
  };
  const prepareAdded = root => {
    if (!(root instanceof Element)) return;
    const card = root.closest(cardSelector);
    if (card) prepareCard(card);
    root.querySelectorAll(cardSelector).forEach(prepareCard);
  };
  window.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest(buttonSelector);
    const card = button?.closest(cardSelector);
    const destination = card && destinationFor(card);
    if (!destination) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(destination.href);
  }, true);
  document.querySelectorAll(cardSelector).forEach(prepareCard);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(prepareAdded));
  }).observe(document.body, { childList: true, subtree: true });
})();
